import { motion } from 'framer-motion';
import ProjectCard from './ProjectCard';
import { projects } from '../data/siteData';
import { luxuryEase, viewportOnce } from '../lib/motion';

export default function Projects({ onProjectClick }) {
  const featured = projects.find((p) => p.id === 'enez');
  const others = projects.filter((p) => p.id !== 'enez');

  return (
    <section id="projects" className="py-24 px-4 sm:px-6 lg:px-8 bg-nosta-cream">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportOnce}
          transition={{ duration: 0.9, ease: luxuryEase }}
          className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6"
        >
          <div>
            <p className="eyebrow mb-4">Portföy</p>
            <h2 className="font-display text-4xl md:text-6xl leading-tight">Projelerimiz</h2>
          </div>
          <p className="text-nosta-mute max-w-md leading-relaxed">
            Satıştaki Enez Villaları ve tamamlanmış Bayramoğlu referansımız — aynı kalite çizgisinde.
          </p>
        </motion.div>

        {featured && (
          <div className="mb-16">
            <p className="eyebrow mb-5">Öne çıkan</p>
            <ProjectCard project={featured} featured onClick={() => onProjectClick(featured.id)} />
          </div>
        )}

        {others.length > 0 && (
          <div>
            <p className="eyebrow mb-5">Referans</p>
            <div className={`grid grid-cols-1 gap-8 ${others.length > 1 ? 'md:grid-cols-2' : ''}`}>
              {others.map((p) => (
                <ProjectCard key={p.id} project={p} onClick={() => onProjectClick(p.id)} />
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
